// we might make calls to different servers, this class accounts for different URLs
// and authentication tokens


//todo: rename file
import {IParcelWebHttpClient} from "./IParcelWebHttpClient";
import {IApiClient} from "./IApiClient";
import {AuthenticationManager} from "./AuthenticationManager";
import {Router} from "@/rawdogjs/src/router";
import {ParcelWebHttpClient} from "./ParcelWebHttpClient";
import {AxiosResponse} from "axios";
import {UrlHelper} from "../../../shared/UrlHelper";

export class ApiClientBase implements IApiClient {

    public _url: string;
    public _path: string;
    public _httpClient: IParcelWebHttpClient;
    public _authenticationManager: AuthenticationManager;
    public _router: Router;

    protected constructor(
        path: string,
        router: Router,
        httpClient: ParcelWebHttpClient,
        authenticationManager: AuthenticationManager,
        url: string = null,
    ) {
        this._path = path;
        this._router = router;
        this._httpClient = httpClient;
        this._authenticationManager = authenticationManager;
        this._url = url;
    }

    async post(data: any, parentTenantId: string | null, useAuthentication: boolean = true, includeCredentials: boolean = false) {

        const options =
            await this.createRequest(
                data,
                parentTenantId,
                useAuthentication,
                includeCredentials
            );

        try {
            const response = await this._httpClient.post(options);
            return response;
        } catch (error) {
            
            if (error?.status === 401) {
                // try to acquire new bearer token, then retry request
                // this seems simpler than the retry logic on the thick client
                const retryOptions =
                    await this.createRequest(
                        data,
                        parentTenantId,
                        useAuthentication,
                        includeCredentials,
                        null,
                        true,
                        true
                    );
                
                return await this._httpClient.post(retryOptions);
            }
            
            throw error;
        }

    }

    async put(data: any, parentTenantId: string, useAuthentication: boolean = true): Promise<AxiosResponse> {

        const options = await this.createRequest(data, parentTenantId, useAuthentication);

        try {
            return this._httpClient.put(options);
        } catch (error) {
            if (error.status === 401) {
                // try to acquire new bearer token, then retry request
                // this seems simpler than the retry logic on the thick client
                await this._authenticationManager.getBearerToken()
                return await this._httpClient.put(options);
            }
            
            throw error;
        }

    }

    async get(
        id: string,
        parentTenantId: string,
        params: any = undefined,
        useAuthentication: boolean = true,
        withCredentials: boolean = false,
        forwardToLogin: boolean = true
    ) {
        let url = this._path;

        if (id) {
            url = `${url}/${id}`
        }

        if (params) {
            let queryString = UrlHelper.getQuery(params);
            url = `${url}?${queryString}`
        }

        const options =
            await this.createRequest(
                null,
                parentTenantId,
                useAuthentication,
                withCredentials,
                url,
                forwardToLogin
            );

        try {
            return this._httpClient.get(options);
        } catch (error) {
            
            if (error.status === 401) {
                // try to acquire new bearer token, then retry request
                // this seems simpler than the retry logic on the thick client
                const retryOptions =
                    await this.createRequest(
                        null,
                        parentTenantId,
                        useAuthentication,
                        withCredentials,
                        url,
                        forwardToLogin,
                        true
                    );
                return await this._httpClient.get(retryOptions);
            }
            
            throw error;
        }

    }

    // for use with endpoints that return 404, translate to null
    public async tryGet(
        id: string,
        parentTenantId: string,
        params: any = undefined,
        useAuthentication: boolean = true,
        withCredentials: boolean = false,
        forwardToLogin: boolean = true
    ) {

        return await this.safeApiCall(async () => {
                return await this.get(id, parentTenantId, params, useAuthentication, withCredentials, forwardToLogin);
            }
        )

    }

    async createRequest(
        data: any,
        parentTenantId: string | null,
        useAuthentication: boolean,
        includeCredentials: boolean = false,
        pathOverride: string = null,
        forceForwardToLogin: boolean = true,
        forceNewBearerToken: boolean = false
    ) {

        // try {

        const requestOptions = {
            url: pathOverride != null ? this._url + pathOverride : this._url + this._path,
            headers: {
                'Content-Type': 'application/json',
                'X-Tenant-Id': parentTenantId ?? ''
            }
        };

        // todo: use typed versions
        if (data)
            requestOptions['data'] = data;

        if (includeCredentials)
            requestOptions['withCredentials'] = true;

        // authenticationManager is not required for anonymous calls
        if (useAuthentication && this._authenticationManager) {
            const bearerToken = await this._authenticationManager.getBearerToken(forceNewBearerToken);

            // tell user to login
            if (!bearerToken) {
                if (forceForwardToLogin)
                    this._router.navigate("/#/login");
            } else {
                requestOptions.headers['Authorization'] = `Bearer ${bearerToken}`;
            }
        }

        return requestOptions;
        //
        // } catch (error) {
        //
        //     // cannot get bearer token, ask user to login again
        //     this._router.navigate('/#/login');
        //
        // }

    }


    public async safeApiCall(apiCall: Function): Promise<AxiosResponse<any> | null> {
        try {
            return await apiCall();
        } catch (e: any) {
            if (e.status === 404) {
                return null;
            } else {
                alert('Server encountered an error.');
                throw e;
            }
        }
    }

}


